// extracted by mini-css-extract-plugin
export default {"footerContainer":"wEJgpNMHgNwHbkiO_WMc","valid":"rRxXqjBBPKFFOA0gV7p5","cancel":"UBr4WQnVzjvngfmMAyYa"};